var exports = {
  "kL": "DiscoverySearchFilters.module__container___dUpUS0",
  "uW": "DiscoverySearchFilters.module__section___dUpUS0",
  "SF": "DiscoverySearchFilters.module__sectionHeading___dUpUS0",
  "jv": "DiscoverySearchFilters.module__categoryList___dUpUS0",
  "af": "DiscoverySearchFilters.module__categoryItem___dUpUS0",
  "Cm": "DiscoverySearchFilters.module__categoryItemActive___dUpUS0",
  "Jm": "DiscoverySearchFilters.module__categoryLabel___dUpUS0",
  "_E": "DiscoverySearchFilters.module__categoryCount___dUpUS0",
};

module.exports = exports;
